import React from 'react';

const TimerDisplay = ({ time }) => {
    const formatTime = (time) => {
        const milliseconds = Math.floor((time % 1000) / 10);
        const seconds = Math.floor((time / 1000) % 60);
        const minutes = Math.floor((time / (1000 * 60)) % 60);
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}:${milliseconds.toString().padStart(2, '0')}`;
    };

    return (
        <span style={{
            fontSize: '1.3rem',
            fontWeight: 'bold',
            color: '#b0b0b0', // match nav-link-inactive gray
            textShadow: '0 0 4px #000, 0 0 1px #afb3eb',
            letterSpacing: '0.1em',
            userSelect: 'none',
            textAlign: 'center',
            display: 'inline-block',
        }}>
            {formatTime(time)}
        </span>
    );
};

export default TimerDisplay;
